import React, { useState, useEffect } from "react";
import { Image, Button, Icon, Confirm } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { ClientDB_API } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ClientDBcreatorForm } from "../ClientDBcreatorForm";
import "./ClientDBcreatorItems.scss";

const clientController = new ClientDB_API();

export function ClientDBcreatorItems(props) {
  const { client, onReload } = props;
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [createDB, setCreateDB] = useState(false);
  const { accessToken } = useAuth();

  // Llamada a la API para verificar si la DB ya existe cuando el componente se monta
  useEffect(() => {
    const checkUserDB = async () => {
      try {
        const result = await clientController.checkUserDBExists(client._id);
        setCreateDB(result); // Establece el estado de createDB basado en el valor devuelto por la API (true/false)
      } catch (error) {
        console.error("Error al verificar la existencia de userDB:", error);
      }
    };

    checkUserDB(); // Ejecuta la función cuando el componente se monta
  }, [client._id]); // Se ejecuta cada vez que cambie el ID del cliente

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const openUpdateClient = () => {
    setTitleModal(`Editando ${client.title}`);
    onOpenCloseModal();
  };

  const onDelete = async () => {
    try {
      await clientController.deleteClient(accessToken, client._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(client._id);
    alert("Client ID copiado al portapapeles");
  };

  const createDBApi = async () => {
    try {
      await clientController.createUserDB(accessToken, client._id);
    } catch (error) {
      console.log("Error al crear la DB:", error.message || error); // Asegúrate de que esto solo maneje verdaderos errores.
    }
    setCreateDB(true);
    onReload();
  };

  return (
    <>
      <div className="client-item">
        <div className="client-item__info">
          <Image src={`${client.miniature}`} />
          <div>
            <h1>{client.client}</h1>
            <h2>{client.title}</h2>
            <p>
              {client._id}{" "}
              <Button icon size="mini" onClick={copyToClipboard}>
                <Icon name="copy" />
              </Button>
            </p>
          </div>
        </div>
        <div className="client-item__buttons">
          <Button
            key={createDB} // Esto forzará una re-renderización cuando `createDB` cambie
            icon
            fluid
            color={createDB ? "green" : "orange"}
            onClick={() => {
              if (createDB) {
                // Construir la URL con el parámetro id
                const urlWithId = `${client.url}?id=${client._id}`;
                window.location.href = urlWithId;
              } else {
                createDBApi(); // Llamar a la función que crea la base de datos
              }
            }}
          >
            {createDB ? "ENTRAR" : "CREAR DB"}
          </Button>
          <div className="client-item__action-buttons">
            <Button icon primary onClick={openUpdateClient}>
              <Icon name="pencil" />
            </Button>
            <Button icon color="red" onClick={onOpenCloseConfirm}>
              <Icon name="trash" />
            </Button>
          </div>
        </div>
      </div>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <ClientDBcreatorForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          client={client}
        />
      </BasicModal>
      <Confirm
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={`Eliminar el curso ${client.title}`}
        size="mini"
      />
    </>
  );
}
